import "oc-interaction/events/pantouch.js";
import I18N from "oc-I18N";
import Dialogs from "./Dialogs.js";
import Commons from "oc-commons/Commons.js";
import Doms from "oc-commons/Doms.js";
import Drags from "oc-interaction/Drags.js";

function addDialog(component) {
    $('body').append(component);
    return component;
}

function removeDialog(component) {
    component.trigger('removed');
    component.remove();
    return component;
}

function messageWithSymbol(symbol,message) {
    return Doms.div({style: "display:table;width:100%;"},
        Doms.div({style: "display:table-row;"},
            Doms.div({style: "display:table-cell;width:4em"},
                Doms.div('.dialog-symbol.fa.'+symbol)),
            Doms.div({style: "display:table-cell;"},
                Doms.div('.message',message))
        ))
}

function buttonsDialog(message,clazz='isa_feedback',buttonAndActionList=[],hideDialogFn=()=>{}) {
    return Doms.div('.dialog.'+clazz,[
        Doms.div('div',message),
        Doms.div('.buttons',buttonAndActionList.map(action=>
            Doms.div('.button'+(action.primary?'.primary':''),action.label)
                .on('tap',()=>{
                    $(this).addClass('clicked');
                    _.delay(()=>{
                        hideDialogFn();
                        if (action.action) {
                            action.action();
                        }
                    },150)
                })
        ))
    ]);
}

Dialogs.show = (component, options) => {

    options = Commons.defaultsDeepSafe({},options,{
        dialogContainer: '#modal.gray',
        duration: null,
        fadeOut: true,
        fadeIn: true,
        closeOnTap: false,
        closeOnTapModalBackground: false,
        draggableByTitle: false,
    });

    var dialog = options.dialogContainer ? Doms.div(options.dialogContainer,component) : component;

    dialog.showDialog = () => {
        addDialog(dialog);
        component.center();
        dialog.hide().fadeIn();
    }

    dialog.hideDialog = () => {
        var remove = () => {
            removeDialog(dialog);
        };
        if (options.fadeOut) {
            dialog.fadeOut(remove);
        } else {
            remove();
        }
    };
    dialog.showDialog();

    if (options.duration) {
        _.delay(dialog.hideDialog,options.duration);
    }

    if (options.closeOnTap) {
        dialog.on('tap',dialog.hideDialog);
    } if (options.closeOnTapModalBackground) {
        dialog.onSafe('tap',(element,event)=>{
            if ($(event.target).attr('id')=='modal') {
                dialog.hideDialog();
            }
        });
    }

    if (options.draggableByTitle) {
        Drags.makeUiElementMoveable(dialog,$('.dialog-title',dialog));
    }

    $('.dialog-close',dialog).on('tap',()=>dialog.hideDialog());

    return dialog;
}

Dialogs.showToast = (message, duration = 2000) => {
    return Dialogs.show(Doms.div('.toast',message),{
        duration: duration,
        dialogContainer: null,
    });
}

Dialogs.showWarning = (message) => {
    var dialog = Dialogs.show(buttonsDialog(messageWithSymbol('fa-warning',message),'isa_warning',[
        {label: 'OK', primary: true, action: function() {} }
    ],()=>dialog.hide()));
    return dialog;
}

Dialogs.showError = (message) => {
    return Dialogs.show(Doms.div('.isa_error.dialog',messageWithSymbol('fa-warning',message)));
}

Dialogs.askQuestion = (message,buttonAndActionList) => {
    var dialog = Dialogs.show(buttonsDialog(Doms.div('.message.center',message),'isa_feedback',buttonAndActionList,()=>dialog.hide()));
    return dialog;
}

Dialogs.askQuestionOkOrCancel = (message,okLabel=I18N('OK'),okFun=()=>{},cancelFun = ()=>{}) => {
    Dialogs.askQuestion(message,[
        {label: okLabel, primary: true, action: okFun },
        {label: I18N('Abbrechen'), action: cancelFun },
    ]);
}

Dialogs.showOk = (message,okFun=()=>{}) => {
    Dialogs.askQuestion(message,[
        {label: I18N('OK'), primary: true, action: okFun },
    ]);
}

Dialogs.showWaiting = (message)  => {
    if (message != null) {
        return Dialogs.show(Doms.div('.toast',message),{
            fadeOut: false,
        });
    }
    return {
        hide: () => {
        }
    };
}


Dialogs.showHtml = (htmlElement,options) => {
    return Dialogs.show($(htmlElement),Commons.defaultsDeepSafe({},options,{
        fadeOut: false,
    }));
};

export default Dialogs;